import { createMission, MissionId, updateMission } from '@wwf/sdk';
import { missionInputToEditionInput } from '@domain/mission';
import type { MissionInput } from '@domain/mission';
import type { DataProvider } from 'react-admin';
import { createRestProvider } from '../factories/createRestProvider';
import { toRecord } from '../utils';

const baseMissionProvider = createRestProvider({
    path: 'missions',
});

export const missionProvider: Partial<DataProvider> = {
    ...baseMissionProvider,

    create: async (resource, params) => {
        const input = missionInputToEditionInput(params.data as MissionInput);
        const data = await createMission(input);
        return { data: toRecord(data) as any };
    },

    update: async (resource, params) => {
        const input = missionInputToEditionInput(params.data as MissionInput);
        const data = await updateMission(params.id as MissionId, input);
        return { data: { ...toRecord(data), id: params.id } as any };
    },
};
